import { apiClient as api } from "./httpClient";

/**
 * Resumo atendimentos dia (RN-223, item 194): todos os atendimentos de um dia, com o status (mesmo os não
 * executados), o convênio/plano e o pagamento — situação, forma(s) e data. Excluído da agenda não entra.
 */
export interface DayAttendanceRow {
  scheduleId: string;
  start: string;
  end: string;
  patientId: string;
  patientName: string;
  professionalName: string;
  serviceName: string;
  planName: string;
  confirmation: string;
  confirmationColor: string | null;
  presence: string;
  presenceColor: string | null;
  /** "Pago", "Pendente" (presença que cobra, sem baixa) ou "—" (não gera cobrança). */
  paymentSituation: string;
  paymentMethods: string;
  paymentDate: string | null;
  normalValue: number;
  discount: number;
  finalValue: number;
  paymentId: string | null;
  beforeCutoff: boolean;
}

export interface DayAttendanceGroup {
  name: string;
  count: number;
  total: number;
}

export interface DayAttendanceOption {
  id: string;
  name: string;
}

export interface DayAttendancesReport {
  date: string;
  count: number;
  realized: number;
  paid: number;
  pending: number;
  byConfirmation: DayAttendanceGroup[];
  byPresence: DayAttendanceGroup[];
  byPaymentMethod: DayAttendanceGroup[];
  byPlan: DayAttendanceGroup[];
  items: DayAttendanceRow[];
  plans: DayAttendanceOption[];
  paymentMethodOptions: DayAttendanceOption[];
  statusOptions: DayAttendanceOption[];
  professionals: DayAttendanceOption[];
}

export interface DayAttendancesFilters {
  date: string;
  healthPlans: string[];
  paymentMethods: string[];
  statuses: string[];
  professionalId: string;
  paymentSituation: string;
}

const query = (f: DayAttendancesFilters): string => {
  const params = new URLSearchParams();
  params.append("date", f.date);
  if (f.healthPlans.length) params.append("healthPlans", f.healthPlans.join(","));
  if (f.paymentMethods.length) params.append("paymentMethods", f.paymentMethods.join(","));
  if (f.statuses.length) params.append("statuses", f.statuses.join(","));
  if (f.professionalId) params.append("professionalId", f.professionalId);
  if (f.paymentSituation) params.append("paymentSituation", f.paymentSituation);
  return `?${params.toString()}`;
};

export const dayAttendancesService = {
  get: async (filters: DayAttendancesFilters): Promise<DayAttendancesReport> => {
    const response = await api.get(`/reports/day-attendances${query(filters)}`, { timeout: 60000 });
    return response.data;
  },

  exportXlsx: async (filters: DayAttendancesFilters): Promise<Blob> => {
    const response = await api.get(`/reports/day-attendances/export${query(filters)}`, {
      responseType: "blob",
      timeout: 60000,
    });
    return response.data;
  },
};
